module.exports = __webpack_public_path__ + "img/5G.c6d9d33a.png";